import React from 'react'
import styled from 'styled-components'
import SpinnerAtom from '../../to_forms/spinner/spinner.atom'
import spinnerStyles from './page_spinner.styles'

const apAtomName = {ap_atom_name: 'apPageSpinnerAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${spinnerStyles}
`

const PageSpinnerAtom: React.FC = function () {
  return (
    <StyledWrapper {...apAtomName}>
      <div className="container">
        <SpinnerAtom ap_type="app_spinner" />
      </div>
    </StyledWrapper>
  )
}

export default PageSpinnerAtom
